var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.507,
    height: 24.51,
    viewBox: "0 0 24.507 24.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1771",
    transform: "translate(.75 .76)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3131",
    d: "M1384.07 1187.07a8 8 0 1 0-3.7 4.43",
    transform: "translate(-1368.493 -1176.501)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3132",
    d: "m1384.07 1187.07 7.43 7.43v5h-4",
    transform: "translate(-1368.493 -1176.501)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 780",
    transform: "translate(11.877 14.999)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M1.13 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 781",
    transform: "translate(13.001 15)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 782",
    transform: "translate(13.001 17)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M2 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 783",
    transform: "translate(15.001 17)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 784",
    transform: "translate(15.001 19)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M2 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 785",
    transform: "translate(17.001 19)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 0v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 786",
    transform: "translate(17.001 21)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M2 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 787",
    transform: "translate(19.001 21)",
    style: {
      stroke: "#191919",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    d: "M0 2V0"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 399",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(4.001 4)",
    style: {
      stroke: "#2a32ff",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8c124af73b404e1ddeb37295532b9e37.svg";
export { ForwardRef as ReactComponent };